/**
 * bz-shipping-fee-product.js — blechziegel.de
 *
 * Hält automatisch einen gestaffelten Versandkosten-Artikel (DE) im Warenkorb:
 *   0,01 € – 99,99 €   → 6,99-€-Variante (lowVariantId)
 *   100,00 € – 799,99 € → 10,99-€-Variante (midVariantId)
 *   ab 800,00 €         → kein Versandartikel (kostenloser Versand)
 *
 * Aktivierung: window.BZ_SHIPPING_FEE_CONFIG (gesetzt via snippets/bz-cart-drawer.liquid)
 *   enabled          : boolean  — Master-Kill-Switch
 *   lowVariantId     : string   — Variant-ID 6,99 €
 *   midVariantId     : string   — Variant-ID 10,99 €
 *   tierLowMaxCents  : number   — Obergrenze Tier Low (default 9999)
 *   tierMidMinCents  : number   — Untergrenze Tier Mid (default 10000)
 *   tierMidMaxCents  : number   — Obergrenze Tier Mid (default 79999)
 *   freeFromCents    : number   — Gratisversand ab (default 80000)
 *   variantId        : string   — Legacy-Fallback falls lowVariantId leer
 *   debug            : boolean  — console.log-Ausgaben
 *
 * Trigger: CustomEvent "bz:cart:synced" (dispatched von bz-cart-drawer.liquid nach
 *   jedem fetchCart / changeLine).
 *
 * Race-Condition-Schutz: globaler _bzSFPLock verhindert Re-Entranz.
 *
 * Musterartikel-Ausschluss:
 *   Artikel mit handle === 'pv-blechziegel-muster' oder product_type === 'Muster'
 *   zählen nicht in den chargeableSubtotal und lösen keinen Versandartikel aus.
 *
 * Kill-Switch (enabled=false):
 *   Alle bekannten Versandkosten-Varianten werden aus dem Warenkorb entfernt.
 */
(function () {
  'use strict';

  if (window._bzSFPLoaded) return;
  window._bzSFPLoaded = true;

  var _lock = false;

  function cfg() {
    return window.BZ_SHIPPING_FEE_CONFIG || {};
  }

  function log(msg) {
    if (cfg().debug) console.log('[BZ-SFP]', msg);
  }

  // Musterartikel-Erkennung — identisch mit isSampleItem() in bz-cart-drawer.liquid.
  function isSampleItem(item) {
    return !!item && (
      item.handle === 'pv-blechziegel-muster' ||
      item.product_type === 'Muster'
    );
  }

  // Alle bekannten Versandkosten-Variant-IDs (normalisiert als Strings).
  function getShippingVariantIds() {
    var c = cfg();
    var ids = [];
    var low = String(c.lowVariantId || c.variantId || '').trim();
    var mid = String(c.midVariantId || '').trim();
    if (low) ids.push(low);
    if (mid && mid !== low) ids.push(mid);
    return ids;
  }

  // Prüft ob ein Cart-Item ein Versandkosten-Artikel ist.
  function isShippingFeeItem(item) {
    if (!item) return false;
    var id = item.variant_id.toString();
    return getShippingVariantIds().indexOf(id) !== -1;
  }

  function getRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.replace(/\/$/, '') + '/';
  }

  async function apiFetch(path, opts) {
    try {
      var res = await fetch(getRoot() + path, opts || {});
      if (!res.ok) { log('HTTP ' + res.status + ' on ' + path); return null; }
      return await res.json();
    } catch (e) { log('Fetch error: ' + e); return null; }
  }

  function fetchCart() {
    return apiFetch('cart.js', { headers: { Accept: 'application/json' } });
  }

  function cartAdd(variantId) {
    return apiFetch('cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    });
  }

  function cartChange(key, quantity) {
    return apiFetch('cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
  }

  // Ziel-Variante anhand des chargeableSubtotals bestimmen.
  // Gibt Variant-ID-String zurück oder null (= kein Versandartikel nötig).
  function resolveTargetVariant(chargeableSubtotal) {
    var c = cfg();
    var low = String(c.lowVariantId || c.variantId || '').trim();
    var mid = String(c.midVariantId || '').trim();
    var tierLowMax = c.tierLowMaxCents !== undefined ? c.tierLowMaxCents : 9999;
    var tierMidMin = c.tierMidMinCents !== undefined ? c.tierMidMinCents : 10000;
    var tierMidMax = c.tierMidMaxCents !== undefined ? c.tierMidMaxCents : 79999;
    var freeFrom = c.freeFromCents !== undefined ? c.freeFromCents : 80000;

    if (chargeableSubtotal <= 0) return null;
    if (chargeableSubtotal >= freeFrom) return null;
    if (chargeableSubtotal >= tierMidMin && chargeableSubtotal <= tierMidMax) {
      if (mid) return mid;
      // mid nicht konfiguriert → Fehlerfall: alle SFP entfernen und warnen
      if (c.debug) console.warn('[BZ-SFP] midVariantId nicht gesetzt — Versandkostenartikel wird entfernt');
      return null;
    }
    if (chargeableSubtotal >= 1 && chargeableSubtotal <= tierLowMax) {
      if (low) return low;
      if (c.debug) console.warn('[BZ-SFP] lowVariantId nicht gesetzt — Versandkostenartikel wird entfernt');
      return null;
    }
    return null;
  }

  /**
   * Zentrale Sync-Funktion.
   * Gibt true zurück wenn Änderungen vorgenommen wurden.
   */
  async function syncShippingFee() {
    var c = cfg();
    var shippingVids = getShippingVariantIds();

    // --- Kill-Switch ---
    if (!c.enabled) {
      var cart = await fetchCart();
      if (!cart) return false;
      var found = cart.items.filter(isShippingFeeItem);
      if (found.length === 0) { log('Feature OFF, keine Versandartikel im Cart'); return false; }
      log('Feature OFF — ' + found.length + ' Versandartikel entfernen');
      for (var i = 0; i < found.length; i++) { await cartChange(found[i].key, 0); }
      return true;
    }

    // --- Feature aktiv, aber keine Variant-IDs ---
    if (shippingVids.length === 0) {
      if (c.debug) console.warn('[BZ-SFP] enabled=true aber keine Variant-IDs gesetzt — Feature inaktiv');
      return false;
    }

    var cart = await fetchCart();
    if (!cart) return false;

    // Bestehende Versandkosten-Artikel im Cart
    var sfpItems = cart.items.filter(isShippingFeeItem);
    // Buchbare Artikel: ohne alle Versandkostenartikel und ohne Musterartikel
    var chargeableItems = cart.items.filter(function (it) {
      return !isShippingFeeItem(it) && !isSampleItem(it);
    });
    var chargeableSubtotal = chargeableItems.reduce(function (s, it) { return s + (it.line_price || 0); }, 0);

    var targetVid = resolveTargetVariant(chargeableSubtotal);

    log('chargeableItems=' + chargeableItems.length +
        ' chargeableSubtotal=' + chargeableSubtotal +
        ' targetVid=' + (targetVid || 'null') +
        ' sfpCount=' + sfpItems.length);

    // --- Kein Versandartikel nötig: alle entfernen ---
    if (!targetVid) {
      if (sfpItems.length === 0) return false;
      log('Kein Versandartikel nötig → alle entfernen (' + sfpItems.length + ')');
      for (var i = 0; i < sfpItems.length; i++) { await cartChange(sfpItems[i].key, 0); }
      return true;
    }

    // --- Ziel-Variante bestimmt: falsche entfernen, richtige sicherstellen ---
    var changed = false;

    // Falsche Varianten entfernen (andere SFP-Varianten)
    var wrongItems = sfpItems.filter(function (it) { return it.variant_id.toString() !== targetVid; });
    if (wrongItems.length > 0) {
      log('Falsche Varianten (' + wrongItems.length + ') entfernen');
      for (var i = 0; i < wrongItems.length; i++) { await cartChange(wrongItems[i].key, 0); }
      changed = true;
      // Cart neu lesen nach Entfernung
      cart = await fetchCart();
      if (!cart) return true;
      sfpItems = cart.items.filter(isShippingFeeItem);
    }

    // Ziel-Variante im Cart
    var targetItems = sfpItems.filter(function (it) { return it.variant_id.toString() === targetVid; });

    // Nicht vorhanden → hinzufügen
    if (targetItems.length === 0) {
      log('Ziel-Variante ' + targetVid + ' hinzufügen');
      var result = await cartAdd(targetVid);
      if (!result) { log('Add fehlgeschlagen — Artikel nicht publiziert oder Shopify-Fehler'); }
      return !!result || changed;
    }

    // Duplikate bereinigen (mehr als 1)
    if (targetItems.length > 1) {
      log('Duplikate (' + targetItems.length + ') → auf 1 reduzieren');
      for (var i = 1; i < targetItems.length; i++) { await cartChange(targetItems[i].key, 0); }
      return true;
    }

    // Menge korrigieren falls nicht 1
    if (targetItems[0].quantity !== 1) {
      log('Menge ' + targetItems[0].quantity + ' → auf 1 setzen');
      await cartChange(targetItems[0].key, 1);
      return true;
    }

    log('Versandartikel korrekt (' + targetVid + ', 1×) — keine Änderung');
    return changed;
  }

  async function handleTrigger() {
    if (_lock) { log('Lock aktiv — Trigger übersprungen'); return; }
    _lock = true;
    try {
      var changed = await syncShippingFee();
      if (changed) {
        log('Änderungen vorgenommen → Drawer aktualisieren');
        if (window.bzCart && typeof window.bzCart.update === 'function') {
          await window.bzCart.update();
        }
      }
    } catch (e) {
      log('Unerwarteter Fehler: ' + e);
    } finally {
      _lock = false;
    }
  }

  document.addEventListener('bz:cart:synced', function () {
    handleTrigger();
  });

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function () {
    setTimeout(handleTrigger, 200);
  });

})();
